import {
  composeSchema,
  createTextEditor,
  createListEditor,
  createSingleDropdownEditor,
  createNumberEditor,
  createDatePickerEditor,
  createMarkdownRteEditor,
} from '@refract-cms/core';
import Icon from '@material-ui/icons/DateRange';

export const CenturySchema = composeSchema({
  options: {
    alias: 'century',
    displayName: 'Century',
    icon: Icon,
    // defaultSort: {
    //   orderByField: 'numberValue',
    //   orderByDirection: 'ASC',
    // },
    instanceDisplayProps: ({ name }) => {
      return {
        primaryText: name,
      };
    },
  },
  properties: {
    name: {
      type: String,
      displayName: 'Name',
      editorComponent: createTextEditor(),
    },
    // numberValue: {
    //   type: Number,
    //   displayName: 'Number Value',
    //   editorComponent: createNumberEditor({
    //     numberType: 'INT',
    //     maxLength: 20,
    //   }),
    // },
  },
});
